import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { ApiConstants } from '../../shared/constants/api-constants';
import { Observable } from 'rxjs';
import { DocumentTransitionDetails } from '../models/document-transition-details';

@Injectable({
  providedIn: 'root'
})
export class DocumentAuditService {
  constructor(private httpClient: HttpClient) {

  }

  getDocumentTransitionDetails = (documentNumber: string, documentVersion: string):
    Observable<DocumentTransitionDetails> => {
    return this.httpClient.get<DocumentTransitionDetails>(
      ApiConstants.Document_Transition_Details_Api +
      '/' +
      `${documentNumber}` +
      '/' +
      `${documentVersion}`,
    );
  }
}
